import { render, staticRenderFns } from "./CoreValues.vue?vue&type=template&id=ede5729e&scoped=true"
import script from "./CoreValues.vue?vue&type=script&lang=js"
export * from "./CoreValues.vue?vue&type=script&lang=js"
import style0 from "./CoreValues.vue?vue&type=style&index=0&id=ede5729e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede5729e",
  null
  
)

export default component.exports